/** True when a roster row still has minutes to score into balanced lines. */
export function playerHasScorableProjection(player) {
  if (!player) return false
  const minutes = Number(player.projected_minutes)
  return Number.isFinite(minutes) && minutes > 0
}

/**
 * Drop leftover house/client probability rows for players whose saved
 * projection minutes are zero. Players missing from the roster are kept.
 */
export function filterLinesForScorableProjections(lines, rosterPlayers) {
  const minutesByPlayer = new Map()
  for (const player of rosterPlayers || []) {
    const id = player?.player_id ?? player?.player?.id
    if (id == null) continue
    minutesByPlayer.set(String(id), Number(player.projected_minutes))
  }

  return (Array.isArray(lines) ? lines : []).filter((line) => {
    if (!minutesByPlayer.has(String(line?.player_id))) return true
    const minutes = minutesByPlayer.get(String(line.player_id))
    return Number.isFinite(minutes) && minutes > 0
  })
}
